export default __webpack_public_path__ + "static/media/BIReports.3dd14a8f.svg";